var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldKeyhole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82486 4.31326C4.35198 4.43716 3.99998 4.85833 3.9974 5.34716L3.99542 5.69913C3.9652 10.9001 3.94405 14.54 9.52764 17.7378C9.81935 17.9049 10.1807 17.9049 10.4724 17.7378C16.056 14.54 16.0348 10.9 16.0046 5.69898L16.0026 5.34717C16 4.85833 15.648 4.43716 15.1751 4.31326C14.1791 4.05227 12.4064 3.47887 10.5623 2.35806C10.2174 2.14839 9.78263 2.14839 9.43765 2.35806C7.59355 3.47887 5.82094 4.05227 4.82486 4.31326ZM12 9.00005C12 9.80656 11.5226 10.5016 10.835 10.8179V13.0001C10.835 13.4612 10.4612 13.8351 10 13.8351C9.53885 13.8351 9.16501 13.4612 9.16501 13.0001V10.8179C8.47739 10.5016 8 9.80657 8 9.00005C8 7.89548 8.89543 7.00005 10 7.00005C11.1046 7.00005 12 7.89548 12 9.00005Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldKeyhole);
export default __webpack_public_path__ + "static/media/shield-keyhole.ef35a5e289e880878ad549f612cb91b3.svg";
export { ForwardRef as ReactComponent };